import React, { useState } from "react";
import Navbar from "./Essentials/Navbar";
import Footer from "./Essentials/Footer";
import "./Css/VTC.css"

const VTC_DATA = {
  overview: {
    title: "Viśvakarmān Technological Center",
    tagline: "The Engineering & Solutions Wing of NFRAC",
    desc: "VTC serves as the primary bridge between theoretical research and real-world application. We manage the full lifecycle of complex software ecosystems, ensuring NFRAC-Lab's innovations reach both internal teams and global clients through robust, industrial-grade engineering."
  },
  orgs: [
    {
      id: "antar-core",
      name: "Antar Core Org",
      vision: "Engineering Backbone",
      desc: "The central 'Home Ground' development team. Antar Core builds and optimizes the proprietary infrastructure that powers all other divisions, ensuring the entire ecosystem remains scalable and secure.",
      link: "https://nfrac-in.web.app/nfrac_projects"
    },
    {
      id: "tattva-ai",
      name: "Tattva-AI Org",
      vision: "Intelligence Implementation",
      desc: "The dedicated engine that operationalizes breakthroughs from the AIRD Department. It turns theoretical AI innovation into functional, high-performance software modules.",
      link: ""
    },
    {
      id: "yaari",
      name: "Yaari Org",
      vision: "Hyper-Local Connectivity",
      desc: "Redefining social networking through real-time geographical intelligence. Yaari bridges the gap between digital interaction and physical presence.",
      link: "https://yaari-jud.web.app"
    },
    {
      id: "ittahub",
      name: "ITTaHub Org",
      vision: "Developer Ecosystems",
      desc: "Focused on high-performance developer tools and distributed storage. ITTaHub provides secure cross-node synchronization as an industrial-grade alternative to traditional repositories.",
      link: "http://ittahub.web.app"
    },
    {
      id: "edflix",
      name: "EdFlix Org",
      vision: "Media Delivery",
      desc: "A secure, full-stack video delivery ecosystem specifically engineered for educational content, prioritizing low-latency streaming and global accessibility.",
      link: "https://edflix-ittacademy.web.app"
    },
    {
      id: "mcg",
      name: "MCG",
      vision: "Market Strategy",
      desc: "An independent consulting wing focused on external market engagement. MCG bridges complex business challenges with NFRAC's high-performance engineering.",
      link: ""
    }
  ]
};

const VTC = () => {
  const [activeTab, setActiveTab] = useState("overview");

  const scrollToSection = (id) => {
    setActiveTab(id);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="vtc-page">
      <Navbar />
      <div className="vtc-container">
        <aside className="vtc-sidebar">
          <div className="sidebar-sticky">
            <h2 className="sidebar-label">Ecosystem</h2>
            <div>
              <ul>
                <li
                  className={activeTab === "overview" ? "active" : ""}
                  onClick={() => scrollToSection("overview")}
                >
                  Overview
                </li>
                {VTC_DATA.orgs.map((org, idx) => (
                  <li
                    key={idx}
                    className={activeTab === org.id ? "active" : ""}
                    onClick={() => scrollToSection(org.id)}
                  >
                    {org.name}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </aside>
        <main className="vtc-content">
          <section id="overview" className="content-block">
            <span className="eyebrow">{VTC_DATA.overview.tagline}</span>
            <h1>{VTC_DATA.overview.title}</h1>
            <p className="large-p">{VTC_DATA.overview.desc}</p>
          </section>
          {VTC_DATA.orgs.map((org, idx) => (
            <section key={idx} onClick={() => { window.open(org.link, "_self") }} id={org.id} style={{ cursor: "pointer" }} className="content-block org-card">
              <span className="eyebrow">{org.vision}</span>
              <h2>{org.name}</h2>
              <p className="org-desc">{org.desc}</p>
              <div className="status-pill">Active Division</div>
            </section>
          ))}
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default VTC;